<template>
  <div
    class="card video-card video-card-list"
    v-bind:class="dynamicCardClass"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
  >
    <div class="card-body video-card-body-list p-0 d-flex flex-style-video-asset-card">
      <div class='video-card-list-img-container d-flex flex-row align-items-center'>
        <div class='video-card-list-embed-img-container cursor-pointer' v-on:click="selectVideoAsset()">
          <div class="embed-responsive embed-responsive-16by9">
            <img
              v-show="!hovering"
              class="card-img-top embed-responsive-item"
              :src="getPoster()"
              :alt="videoAsset.title"
            />
            <img
              v-show="hovering"
              class="card-img-top embed-responsive-item"
              :src="getGif()"
              :alt="videoAsset.title"
            />
          </div>
        </div>
      </div>
      <div class='d-flex flex-column skeleton-placeholder-content-row'>
        <div class='header-row d-flex justify-content-between'>
          <h3 class="c-title pt-2 pb-2 cursor-pointer" v-on:click="selectVideoAsset()">{{ videoAsset.title }}</h3>
          <div :class="{'base-bookmarked': videoAsset.bookmarkable}" class='video-card-bookmark-container base-bookmark' v-on:click="toggleBookmark()">
            <i v-if="!!videoAsset.bookmarkable" class="fas fa-bookmark"></i>
            <i v-show="!videoAsset.bookmarkable" class="fal fa-bookmark"></i>
          </div>
        </div>
        <span class='text-overflow-clamp cursor-pointer' v-html="videoAsset.description" v-on:click="selectVideoAsset()"></span>
        <div class="agenda__item-tags pb-2" v-if="videoAsset.schedule_item_tags">
          <div v-for="(tag, tagIndex) in videoAsset.schedule_item_tags" 
            class="badge tag-badge agenda__item-tag" 
            v-show="tag.visible" 
            :style="`background-color: ${tag.tag_hex};`" 
            :data-tag-id="tag.id" :data-tag-name="tag.tag" :key="tagIndex"
          >
            {{ tag.tag }}
          </div>
        </div>
        <div class="video-asset__speaker_sections pb-2 d-flex flex-row justify-content-between">
          <div class='video-asset-speaker-section d-flex flex-column' v-show="videoAsset.video_asset_speaker_sections.length">
            <div v-for="(videoAssetSpeakerSection, index) in videoAsset.video_asset_speaker_sections"  :key="index">
              <div class='video-asset-speaker-section-name'>
                {{ videoAssetSpeakerSection.name }}
              </div>
              <VideoAssetSpeaker 
                v-for="(speaker, i) in videoAssetSpeakerSection.video_asset_speakers" 
                :speaker="speaker" 
                :key="i"
              />
            </div>
          </div>
          <div class='video-asset-watch-now-btn-container d-flex flex-column justify-content-end'>
            <button class="btn btn-primary video-list-watch-btn" v-on:click="selectVideoAsset()">
              Watch Now
            </button>
          </div>
        </div>

        <!-- Like session -->
        <div class="agenda__item-likeable-item" v-cloak>
            <likeable-item
              :plugin-type="'VideoAsset'"
              :plugin="videoAsset"
              aria-label="Did you like this video?"
              tabindex="0"
              ></likeable-item>
        </div>
        <!-- /Like session -->

      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../EventBus.js";
import VideoAssetSpeaker from './VideoAssetSpeaker.vue'

export default {
  props: ["videoAsset", "videoAssetVideoPlaylist"],

  data: function () {
    return {
      hovering: false,
    };
  },

  components: {
    VideoAssetSpeaker,
  },

  methods: {

    toggleBookmark () {
      window.EventBus.$emit('video-asset-bookmarkable-toggle', this.videoAsset);
    },

    getPoster() {
      if (this.videoAsset.custom_poster_image_enabled && this.videoAsset.poster_image_url) {
        return this.videoAsset.poster_image_url
      }
      else {
        return this.videoAsset.mux_asset.poster
      }
    },

    getGif() {
      return this.videoAsset.mux_asset && this.videoAsset.mux_asset.gif;
    },

    selectVideoAsset() {
      EventBus.$emit("video-asset-selected", this.videoAsset);
      window.EventBus.$emit(
        "video-asset-video-playlist-selected",
        this.videoAssetVideoPlaylist
      );
    },
  },

  computed: {
    dynamicCardClass () {
      return `select-vavp-${this.videoAssetVideoPlaylist.id}`;
    }
  }
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}

.video-card.video-card-list:hover {
  cursor: auto;
}

.video-card-list-img-container {
  flex-basis: 300px;
  flex-grow: 0;
  margin-right: 1rem;
}

.video-list-watch-btn {
  width: 130px;
}

.video-card-list-embed-img-container {
  width: 100%;
}

.text-overflow-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.flex-style-video-asset-card {
  flex-direction: row;
}

@media (max-width: 991px) {
  .flex-style-video-asset-card {
    flex-direction: column;
  }
  .video-card-list-img-container {
    margin-right: 0rem;
  }

  .video-card-bookmark-container {
    margin-top: 1rem;
  }
}
</style>